import Vue from "vue";
import Vuex from "vuex";

import * as accounts from "@/store/modules/accounts.js";
import * as blog from "@/store/modules/blog.js";
import * as cookies from "@/store/modules/cookies.js";
import * as fixtures from "@/store/modules/fixtures.js";
import * as notifications from "@/store/modules/notifications.js";
import * as offers from "@/store/modules/offers.js";
import * as organizations from "@/store/modules/organizations.js";
import * as payments from "@/store/modules/payments.js";
import * as uploads from "@/store/modules/uploads.js";
import * as users from "@/store/modules/users.js";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        accounts,
        blog,
        cookies,
        fixtures,
        notifications,
        offers,
        organizations,
        payments,
        uploads,
        users,
    }
});
